import { useNavigate } from 'react-router-dom'
import type { BillingStatus } from '../../api/billing'

interface Props {
  billing: BillingStatus | null
}

export default function SubscriptionPaywall({ billing }: Props) {
  const navigate = useNavigate()
  if (!billing?.blocked) return null

  return (
    <div className="subscription-paywall" data-testid="subscription-paywall">
      <div className="subscription-paywall-card">
        <h2>Subscription required</h2>
        <p>
          {billing.subscription_status === 'locked'
            ? 'Your account is locked. Add a payment method to restore full access.'
            : 'Add a payment method to start using SOVIQ AI.'}
        </p>
        <button
          type="button"
          className="btn primary"
          data-testid="subscription-add-payment"
          onClick={() => navigate('/pricing')}
        >
          View plans &amp; checkout
        </button>
        <p className="subscription-paywall-note">Charged today, then on this day each month. Promotion codes accepted at checkout.</p>
      </div>
    </div>
  )
}
